export const API_URL = process.env.REACT_APP_API_URL
export const PATH = process.env.REACT_APP_PATH
// export const PATH = 'http://192.168.10.169/'
export const PATH_LOGIN = process.env.REACT_APP_PATH_LOGIN
